function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import KZUIComponent from '../base/index';
import Button from '../Button';
import './style.less';

var compare = function compare(target, min, max) {
  if (target < min) return min;else if (target > max) return max;
  return target;
};

var ImageCropper = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(ImageCropper, _KZUIComponent);

  var _super = _createSuper(ImageCropper);

  function ImageCropper(props) {
    var _this;

    _classCallCheck(this, ImageCropper);

    _this = _super.call(this, props);
    _this.state = {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      cropped: false
    };

    _this.autoBind('handleMouseDown', 'handleMouseUp', 'handleMouseMove', 'handleConfirm', 'handleImageLoad');

    return _this;
  }

  _createClass(ImageCropper, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window.onmousemove = this.handleMouseMove;
      window.onmouseup = this.handleMouseUp;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      var direction = e.target.getAttribute('data-direction');
      this.direction = direction;
      this.moveStartX = e.screenX;
      this.moveStartY = e.screenY;
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      var offsetX = e.screenX - this.moveStartX;
      var offsetY = e.screenY - this.moveStartY;
      this.moveStartX = e.screenX;
      this.moveStartY = e.screenY;
      var lastX = this.state.x;
      var lastY = this.state.y;
      var lastH = this.state.height;
      var lastW = this.state.width;
      var imageH = this.imageH;
      var imageW = this.imageW;
      var minOffset = 0;
      var minUnit = 10;

      switch (this.direction) {
        case 'all':
          {
            var nowX = lastX + offsetX;
            var maxX = imageW - lastW;
            nowX = compare(nowX, minOffset, maxX);
            var nowY = lastY + offsetY;
            var maxY = imageH - lastH;
            nowY = compare(nowY, minOffset, maxY);
            this.setState({
              x: nowX,
              y: nowY
            });
            break;
          }

        case 'n':
          {
            var _nowY = lastY + offsetY;

            var _maxY = lastY + lastH - minUnit;

            offsetY = compare(_nowY, minOffset, _maxY) - lastY;

            var _nowX = lastX + offsetY / 2;

            if (_nowX < minOffset) offsetY = (minOffset - lastX) * 2;
            var allW = lastX + lastW - offsetY / 2;
            if (allW > imageW) offsetY = (lastX + lastW - imageW) * 2;
            this.setState({
              width: lastW - offsetY,
              height: lastH - offsetY,
              x: lastX + offsetY / 2,
              y: lastY + offsetY
            });
            break;
          }

        case 'w':
          {
            var _nowX2 = lastX + offsetX;

            var _maxX = lastX + lastW - minUnit;

            offsetX = compare(_nowX2, minOffset, _maxX) - lastX;

            var _nowY2 = lastY + offsetX / 2;

            if (_nowY2 < minOffset) offsetX = (minOffset - lastY) * 2;
            var allY = lastY + lastH - offsetX / 2;
            if (allY > imageH) offsetX = (lastY + lastH - imageH) * 2;
            this.setState({
              width: lastW - offsetX,
              height: lastH - offsetX,
              x: lastX + offsetX,
              y: lastY + offsetX / 2
            });
            break;
          }

        case 's':
          {
            var nowH = lastH + offsetY;
            var maxH = imageH - lastY;
            offsetY = compare(nowH, minUnit, maxH) - lastH;

            var _nowX3 = lastX - offsetY / 2;

            if (_nowX3 < minOffset) offsetY = (lastX - minOffset) * 2;

            var _allW = lastW + lastX + offsetY / 2;

            if (_allW > imageW) offsetY = (imageW - lastX - lastW) * 2;
            this.setState({
              width: lastW + offsetY,
              height: lastH + offsetY,
              x: lastX - offsetY / 2,
              y: lastY
            });
            break;
          }

        case 'e':
          {
            var nowW = lastW + offsetX;
            var maxW = imageW - lastX;
            offsetX = compare(nowW, minUnit, maxW) - lastW;

            var _nowY3 = lastY - offsetX / 2;

            if (_nowY3 < minOffset) offsetX = (lastY + minOffset) * 2;
            var allH = lastH + lastY + offsetX / 2;
            if (allH > imageH) offsetX = (imageH - lastH - lastY) * 2;
            this.setState({
              width: lastW + offsetX,
              height: lastH + offsetX,
              x: lastX,
              y: lastY - offsetX / 2
            });
            break;
          }

        case 'nw':
          {
            var _nowY4 = lastY + offsetY;

            var _maxY2 = lastY + lastH - minUnit;

            offsetY = compare(_nowY4, minOffset, _maxY2) - lastY;

            var _nowX4 = lastX + offsetY;

            var _maxX2 = lastX + lastW - minUnit;

            offsetY = compare(_nowX4, minOffset, _maxX2) - lastX;
            this.setState({
              width: lastW - offsetY,
              height: lastH - offsetY,
              x: lastX + offsetY,
              y: lastY + offsetY
            });
            break;
          }

        case 'ne':
          {
            var _nowY5 = lastY + offsetY;

            var _maxY3 = lastY + lastH - minUnit;

            offsetY = compare(_nowY5, minOffset, _maxY3) - lastY;

            var _nowW = lastW - offsetY;

            var _maxW = imageW - lastX;

            offsetY = lastW - compare(_nowW, minUnit, _maxW);
            this.setState({
              width: lastW - offsetY,
              height: lastH - offsetY,
              x: lastX,
              y: lastY + offsetY
            });
            break;
          }

        case 'sw':
          {
            var _nowX5 = lastX + offsetX;

            var _maxX3 = lastX + lastW - minUnit;

            offsetX = compare(_nowX5, minOffset, _maxX3) - lastX;

            var _nowH = lastH - offsetX;

            var _maxH = imageH - lastY;

            offsetX = lastH - compare(_nowH, minUnit, _maxH);
            this.setState({
              width: lastW - offsetX,
              height: lastH - offsetX,
              x: lastX + offsetX,
              y: lastY
            });
            break;
          }

        case 'se':
          {
            var _nowW2 = lastW + offsetX;

            var _maxW2 = imageW - lastX;

            offsetX = compare(_nowW2, minUnit, _maxW2) - lastW;

            var _nowH2 = lastH + offsetX;

            var _maxH2 = imageH - lastY;

            offsetX = compare(_nowH2, minUnit, _maxH2) - lastH;
            this.setState({
              width: lastW + offsetX,
              height: lastH + offsetX
            });
            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp() {
      this.direction = '';
      this.moveStartX = 0;
      this.moveStartY = 0;
    }
  }, {
    key: "handleImageLoad",
    value: function handleImageLoad(_ref) {
      var img = _ref.target;
      var origW = img.naturalWidth;
      var origH = img.naturalHeight;
      var calcW = this.props.initWidth;
      var scaleRatio = calcW / origW;
      var calcH = origH * scaleRatio;
      var unit = calcW > calcH ? calcH : calcW;
      var offsetX = calcW - unit - parseInt((calcW - unit) / 2, 10);
      var offsetY = (calcH - unit) / 2;
      this.scaleRatio = scaleRatio;
      this.imageW = calcW;
      this.imageH = calcH;
      this.setState({
        width: unit,
        height: unit,
        x: offsetX,
        y: offsetY
      });
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this2 = this;

      var canvas = this.canvas;
      var ctx = canvas.getContext('2d');
      var image = new Image();

      image.onload = function () {
        var x = _this2.state.x / _this2.scaleRatio;
        var y = _this2.state.y / _this2.scaleRatio;
        var width = _this2.state.width / _this2.scaleRatio;
        var height = _this2.state.height / _this2.scaleRatio;
        var canvasW = _this2.props.scale ? _this2.state.width : width;
        var canvasH = _this2.props.scale ? _this2.state.height : height;
        canvas.height = canvasH;
        canvas.width = canvasW;
        ctx.drawImage(image, x, y, width, height, 0, 0, canvasW, canvasH);

        _this2.setState({
          cropped: true
        });

        _this2.props.handleCrop(canvas.toDataURL());
      };

      image.src = this.props.imgsrc;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$classname,
          _this3 = this;

      var className = this.classname('image-cropper', (_this$classname = {}, _defineProperty(_this$classname, this.props.size, true), _defineProperty(_this$classname, "error", this.props.error), _defineProperty(_this$classname, "disabled", this.props.disabled), _this$classname));
      var width = this.props.initWidth;
      var height = this.props.initWidth;
      var display = this.state.cropped ? 'none' : 'block';
      var containerStyle = {
        display: display,
        width: width
      };
      var boxStyle = {
        width: this.state.width,
        height: this.state.height,
        top: this.state.y,
        left: this.state.x
      };
      var transStyle = {
        top: -this.state.y,
        left: -this.state.x,
        width: width
      };
      var canvasStyle = {
        display: this.state.cropped ? 'block' : 'none',
        width: width
      };
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-cropper-container",
        onMouseDown: this.handleMouseDown,
        style: containerStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-background"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.imgsrc,
        onLoad: this.handleImageLoad,
        style: {
          width: width
        },
        alt: "cropper"
      })), /*#__PURE__*/React.createElement("div", {
        className: "image-mask"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-box",
        style: boxStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-crop-view"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.imgsrc,
        style: transStyle,
        alt: "cropper"
      })), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-move",
        "data-direction": "all"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-line image-crop-line-n",
        "data-direction": "n"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-line image-crop-line-e",
        "data-direction": "e"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-line image-crop-line-s",
        "data-direction": "s"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-line image-crop-line-w",
        "data-direction": "w"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-n",
        "data-direction": "n"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-ne",
        "data-direction": "ne"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-e",
        "data-direction": "e"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-se",
        "data-direction": "se"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-s",
        "data-direction": "s"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-sw",
        "data-direction": "sw"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-w",
        "data-direction": "w"
      }), /*#__PURE__*/React.createElement("div", {
        className: "image-crop-point image-crop-point-nw",
        "data-direction": "nw"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "image-cropper-btns",
        style: {
          display: display
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.handleCancel
      }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        onClick: this.handleConfirm
      }, "\u786E\u5B9A")), /*#__PURE__*/React.createElement("div", {
        className: "image-cropper-canvas",
        style: canvasStyle
      }, /*#__PURE__*/React.createElement("canvas", {
        ref: function ref(c) {
          _this3.canvas = c;
        },
        style: {
          width: width,
          height: height
        }
      })));
    }
  }]);

  return ImageCropper;
}(KZUIComponent);

ImageCropper.propTypes = {
  imgsrc: PropTypes.string.isRequired,
  initWidth: PropTypes.number,
  scale: PropTypes.bool,
  handleCrop: PropTypes.func,
  handleCancel: PropTypes.func
};
ImageCropper.defaultProps = {
  initWidth: 232,
  scale: false,
  handleCrop: function handleCrop() {},
  handleCancel: function handleCancel() {}
};
export default ImageCropper;